import {
  Order
} from '../../../../../core';
import moment from 'moment';
import { DataTable, IconsOfActions } from '../../data-table.interface';
const iconsOfActionsList: IconsOfActions[] = [
{
  icon: 'locate-dispatches',
  tooltip: 'Ubicar'
}
];
export const inStorePicking: DataTable = {
  searchText: '',
  addText: '',
  export: true,
  exportFile: 'Retiro en tienda.xlsx',
  expandable: true,
  filter: false,
  paginator: true,
  filterDefault: '',
  disabled: false,
  partialField: '',
  checkbox: true,
  checkboxHeader: false,
  iconsOfActions: iconsOfActionsList,
  hasDisabledCheckBoxItem: (item:Order)=>{
    return !item.isUbication || item.itemDisabled
  },
  columns: [
    {
      title: 'Empresa',
      name: 'companyCode',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Order) => element.companyCode
    },
    {
      title: 'N° de NV',
      name: 'orderNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center w130',
      value: (element: Order) => element.orderNumber
    },
    {
      title: 'N° de Despacho',
      name: 'dispatchNumber',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Order) => element.dispatchNumber
    },
    {
      title: 'Cliente',
      name: 'customer',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Order) => element.customer
    }, 
    {
      title: 'N° de doc.',
      name: 'customerDocumentNumber',
      type: 'string',
      value: (element: Order) => element.customerDocumentNumber
    },
    {
      title: 'Receptor',
      name: 'receptor',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'left',
      value: (element: Order) => element.receptor
    },
    {
      title: 'N° de doc.',
      name: 'receptorDocumentNumber',
      type: 'string',
      value: (element: Order) => element.receptorDocumentNumber
    },
    {
      title: 'Sucursal de entrega',
      name: 'entity',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Order) => element.entity
    },
    {
      title: 'Fecha de llegada',
      name: 'arrivalDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center w120',
      value: (element: Order) => moment(element.arrivalDate).format('YYYY-MM-DD')
    },
    {
      title: 'Fecha de retiro',
      name: 'retireDate',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center w120',
      value: (element: Order) => element.retireDate ? moment(element.retireDate).format('YYYY-MM-DD') : '---'
    },
    {
      title: "Fecha de vigencia de retiro",
      name: "withdrawalEffectiveDate",
      type: "string",
      editable: false,
      checkAll: false,
      class: "center w120",
      value: (element: Order) => element.withdrawalEffectiveDate ? element.withdrawalEffectiveDate : '----',
    },
    {
      title: 'Agrupación de entidad origen',
      name: 'originGroupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Order) => element.originGroupName
    },
    {
      title: 'Agrupación de entidad final',
      name: 'groupName',
      type: 'string',
      editable: false,
      checkAll: false,
      class: 'center',
      value: (element: Order) => element.groupName
    },
    {
      title: 'Imagen',
      type: 'button',
      name: 'image',
      editable: false,
      checkAll: false,
      class: 'center',
      value: () => {
        return {
          icon: 'photo',
          svg: true,
          tooltip: 'Ver detalles del producto',
          class: 'recordColumn icon-table'
        };
      }
    }
  ],
  subTable: {}
};
